module.exports = __webpack_public_path__ + "assets/daofu.bd29889c.svg";